export default __webpack_public_path__ + "static/bushellsLogo-b60403540c592daa6af2aee5bf78e3aa.png";